/**
 * Centralized environment configuration.
 * All components/services must import from here — never use import.meta.env directly.
 */
export const ENV = {
  /** Display name, e.g. "Evolve Wellness". */
  APP_NAME: import.meta.env.VITE_APP_NAME as string,
  /** Same name without spaces for keys/identifiers, e.g. "EvolveWellness". */
  APP_KEY: (import.meta.env.VITE_APP_KEY as string | undefined) ?? '',

  API: {
    BASE_URL: import.meta.env.VITE_API_BASE_URL as string,
    TIMEOUT: Number(import.meta.env.VITE_API_TIMEOUT) || 15000,
  },

  FLAGS: {
    MOCK_API: import.meta.env.VITE_ENABLE_MOCK_API === 'true',
    REACT_QUERY_DEVTOOLS: import.meta.env.VITE_ENABLE_REACT_QUERY_DEVTOOLS === 'true',
    REDUX_DEVTOOLS: import.meta.env.VITE_ENABLE_REDUX_DEVTOOLS === 'true',
  },

  /** Fullscript Embed config.
   *  - PUBLIC_KEY: tenant publicKey from the Fullscript Integrate
   *    dashboard. Required by the SDK init; treated as non-secret per
   *    Fullscript docs (safe to embed in FE).
   *  - ENV: SDK env code, NOT separate mode + region. Defaults to
   *    `us-snd` (US sandbox) so dev builds never hit production. */
  FULLSCRIPT: {
    PUBLIC_KEY: (import.meta.env.VITE_FULLSCRIPT_PUBLIC_KEY as string) || '',
    ENV: ((import.meta.env.VITE_FULLSCRIPT_ENV as string) || 'us-snd') as
      | 'us'
      | 'ca'
      | 'us-snd'
      | 'ca-snd',
  },
} as const
